import { syncRender } from 'globalCommon/services/syncRender';
import commonPageService from 'pcCommon/services/commonPageService';
import './style.css';

const init = () => {
    commonPageService({ renderAfter: syncRender, isMobile: 'auto' });
};

init();
